module.exports = __webpack_public_path__ + "static/img/108005.0a461156.png";